import { createContext } from 'react';
export var InstantSearchRSCContext = /*#__PURE__*/createContext({
  countRef: {
    current: 0
  },
  waitForResultsRef: null,
  ignoreMultipleHooksWarning: false
});